module.exports = __webpack_public_path__ + "src/assets/img/topbg.41537333.jpg";